import { useEffect } from 'react';
import { useVenue } from '@core/contexts/VenueContext';
import { applyBrandHead, brandHead } from './utils/brandHead';

// Та же база, что у запросов PWA (src/api/client.ts, ядро): https://api…/api/v1 в проде, '/api/v1' — dev-прокси.
const API_BASE = import.meta.env.VITE_API_URL || '/api/v1';

function slugFromPath(): string {
  return window.location.pathname.split('/').filter(Boolean)[0] || '';
}

/** Как можно раньше (main.tsx, до загрузки заведения): манифест и иконки заведения из URL. */
export function applyEarlyBrandHead(): void {
  applyBrandHead(document, brandHead({ slug: slugFromPath(), apiBase: API_BASE }));
}

/** После ответа GET /venues/{slug}: версионированные URL, цвет темы и название — или стандарт Lunit у старого бэкенда. */
export function useVenueBrandHead(): void {
  const { venue, venueSlug, error } = useVenue();
  useEffect(() => {
    // Заведение не загрузилось — ранние адреса бренда, скорее всего, 404: назад к стандарту Lunit.
    if (error) return applyBrandHead(document, brandHead({ slug: '', apiBase: API_BASE }));
    if (!venue) return;
    applyBrandHead(
      document,
      brandHead({ slug: venueSlug, apiBase: API_BASE, branding: venue.branding ?? {}, venueName: venue.name }),
    );
  }, [venue, venueSlug, error]);
}
